<template>
  <div id="technical-capacity">
    <div class="open-platform-header-text">
      <h1>{{ lanInfo.title[2] }}</h1>
    </div>
    <div class="content-width">
      <div class="swiper-container drawer-content" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide v-for="(item,index) of lanInfo.technicalCapacity" v-bind:key="index">
            <div class="capacity-item">
              <img :src="require(`../../assets/images/openPlatform/detail-capacity-${index + 1}.png`)">
              <h3>{{ item.name }}</h3>
              <p>{{ item.text }}</p>
              <div class="capacity-desc">
                {{ item.desc }}
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";


export default {
  name: "openPlatformDetailCapacity",
  components: {swiper, swiperSlide},
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    },
    mySwiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: 'auto',
      },
    }
  },
  methods: {
    onMouseEnter() {
      this.mySwiper.autoplay.stop()
    },
    onMouseLeave() {
      this.mySwiper.autoplay.start()
    }
  },
  inject: ['reload'],
  watch: {
    lanType() {
      this.reload();
    }
  }
}
</script>

<style scoped lang="scss">
.content-width {
  width: 1200px;
  margin: 0 auto;
}

.open-platform-header-text {
  text-align: center;
  padding: 40px 0;

  h1 {
    color: #000000;
    font-size: 26px;
  }
}

/*  */
.drawer-content {
  display: flex;
  position: relative;

  &.swiper-container {
    //width: 1100px;
    margin: 0 auto;
    overflow: hidden;
  }

  .swiper-slide {
    &:nth-child(odd) {
      background: #FAFAFA;
    }

    &:nth-child(even) {
      background: #F5F5F5;
    }
  }
}

#technical-capacity {
  padding-bottom: 60px;

  .capacity-item {
    width: 200px;
    height: 236px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0;
    position: relative;

    img {
      width: 59px;
      height: 59px;
      margin-bottom: 28px;
    }

    h3 {
      color: #2F3030;
      line-height: 25px;
      font-size: 14px;
      text-align: center;
      width: 90%;
    }

    p {
      line-height: 20px;
      font-size: 14px;
      color: #787878;
      margin-top: 8px;
      text-align: center;
      width: 90%;
    }

    .capacity-desc {
      position: absolute;
      background: #0A57C9;
      top: 236px;
      left: 0;
      width: 100%;
      height: 100%;
      color: #FFFDFD;
      font-size: 10px;
      line-height: 16px;
      padding: 20px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      .capacity-desc {
        top: 0;
      }
    }
  }
}

.swiper-container {
  display: flex;
  flex-direction: row;
  //width: 1100px;
  overflow: hidden;
  margin: auto;
  height: 236px;

  .swiper-slide {
    width: 200px !important;
    height: 260px;
  }
}
</style>